/**
 * ChatMessageListReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * ChatMessageListReq
 */
export interface ChatMessageListReq {
  /** 搜索关键词 */
  q?: string
  /** 是否删除 */
  deleted?: boolean
  /** 页码 */
  page?: number
  /** 每页数量 */
  page_size?: number
  /** 排序字段 */
  order_by?: string
  /** 排序方向 */
  order?: string
  /** 创建时间范围 (start,end) */
  created_at__range?: any
  /** 更新时间范围 (start,end) */
  updated_at__range?: any
  /** 更新时间距今 (7d/1h/30m) */
  updated_at__since?: any
  /** 禁用状态 */
  disabled?: boolean
  /** ID列表 */
  id__in?: string[]
  /** 频道类型 */
  channel_type?: string
  /** 频道ID */
  channel_id?: any
  /** 消息CID */
  cid?: string
  /** 发送者ID */
  sender_id?: any
  /** 消息类型 */
  type?: string
  /** 频道类型列表 */
  channel_type__in?: string[]
  /** 发送者ID列表 */
  sender_id__in?: any
  /** 消息类型列表 */
  type__in?: string[]
  /** 消息内容包含 */
  text__like?: string
  /** 是否置顶 */
  pinned?: boolean
  /** 是否静默 */
  silent?: boolean
  /** 是否影子消息 */
  shadowed?: boolean
}

/**
 * ChatMessageListReq Schema
 */
export const ChatMessageListReqSchema: SchemaDefinition = {
  properties: {
    q: {
      description: '搜索关键词',
      format: 'string',
      type: 'string',
      label: '搜索关键词',
    },
    deleted: {
      description: '是否删除',
      format: '*bool',
      type: 'boolean',
      label: '是否删除',
    },
    page: {
      description: '页码',
      format: 'int',
      type: 'integer',
      label: '页码',
    },
    page_size: {
      description: '每页数量',
      format: 'int',
      type: 'integer',
      label: '每页数量',
    },
    order_by: {
      description: '排序字段',
      format: 'string',
      type: 'string',
      label: '排序字段',
    },
    order: {
      description: '排序方向',
      format: 'string',
      type: 'string',
      label: '排序方向',
    },
    created_at__range: {
      description: '创建时间范围 (start,end)',
      format: '[]string',
      type: 'datetime',
      label: '创建时间范围',
    },
    updated_at__range: {
      description: '更新时间范围 (start,end)',
      format: '[]string',
      type: 'datetime',
      label: '更新时间范围',
    },
    updated_at__since: {
      description: '更新时间距今 (7d/1h/30m)',
      format: '[]string',
      type: 'datetime',
      label: '更新时间距今',
    },
    disabled: {
      description: '禁用状态',
      format: '*bool',
      type: 'boolean',
      label: '禁用状态',
    },
    id__in: {
      description: 'ID列表',
      format: '[]string',
      items: {
        format: 'string',
        type: 'string',
      },
      type: 'array',
      label: 'ID列表',
    },
    channel_type: {
      description: '频道类型',
      format: 'cons.ChatChannelType',
      type: 'string',
      label: '频道类型',
    },
    channel_id: {
      description: '频道ID',
      format: 'string',
      type: 'chat_channel',
      label: '频道ID',
    },
    cid: {
      description: '消息CID',
      format: 'string',
      type: 'string',
      label: '消息CID',
    },
    sender_id: {
      description: '发送者ID',
      format: 'string',
      type: 'user',
      label: '发送者ID',
    },
    type: {
      description: '消息类型',
      format: 'cons.ChatMessageType',
      type: 'string',
      label: '消息类型',
    },
    channel_type__in: {
      description: '频道类型列表',
      format: '[]cons.ChatChannelType',
      items: {
        format: 'cons.ChatChannelType',
        type: 'string',
      },
      type: 'array',
      label: '频道类型列表',
    },
    sender_id__in: {
      description: '发送者ID列表',
      format: '[]string',
      type: 'user',
      label: '发送者ID列表',
    },
    type__in: {
      description: '消息类型列表',
      format: '[]cons.ChatMessageType',
      items: {
        format: 'cons.ChatMessageType',
        type: 'string',
      },
      type: 'array',
      label: '消息类型列表',
    },
    text__like: {
      description: '消息内容包含',
      format: 'string',
      type: 'string',
      label: '消息内容包含',
    },
    pinned: {
      description: '是否置顶',
      format: '*bool',
      type: 'boolean',
      label: '是否置顶',
    },
    silent: {
      description: '是否静默',
      format: '*bool',
      type: 'boolean',
      label: '是否静默',
    },
    shadowed: {
      description: '是否影子消息',
      format: '*bool',
      type: 'boolean',
      label: '是否影子消息',
    },
  },
  type: 'object',
}
